import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import jwtService from '@/app/services/jwtService';
import * as Actions from '@/app/store/actions';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, CircularProgress, IconButton } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './adminDetail.css';
import ResetDialoguebox from './ResetDialoguebox';
import { useNavigate } from 'react-router-dom';

const SuperadminDetail = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [user, setuser] = useState([]);
	const userRole = useSelector(({ auth }) => auth.user.role);
	const dispatch = useDispatch();
	const [refresh, setRefresh] = useState(0);
	const isSuperSchoolAdmin = userRole[0] === 'super_school_admin';
	const navigate = useNavigate();
	useEffect(() => {
		let isMounted = true;
		jwtService
			.getProfile(isSuperSchoolAdmin)
			.then((res) => {
				if (!isMounted) return;
				setIsLoading(false);
				setuser(res.data);
			})
			.catch((error) => {
				if (!isMounted) return;
				setIsLoading(false);
				console.error('data is invalid', error);
			});

		return () => {
			isMounted = false;
		};
	}, []);

	const goToEditprofile = () => {
		navigate({
			pathname: ['super_admin', 'comany_owner'].includes(userRole[0]) ? '/Editprofile' : '/profile-edit',
			state: { user },
		});
	};

	const handleResetDialoguebox = () => {
		dispatch(
			Actions.openDialog({
				children: <ResetDialoguebox refresh={refresh} setRefresh={setRefresh} />,
			}),
		);
	};

	return (
		<div className="profile-cont mx-auto">
			<div className="profileinfo flex items-center flex-nowrap justify-between mx-auto">
				<div className="form-heading">
					<span className="">
						<IconButton
							onClick={() => {
								navigate(-1);
							}}
						>
							<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
						</IconButton>
					</span>
					Profile
				</div>

				<div className="personal-button flex justify-between">
					<span className="mx-4 ">
						<CustomButton fontSize="15px" height="46" onClick={goToEditprofile} variant="secondary" width="100px">
							<FontAwesomeIcon icon={faEdit} />
							<span> Edit </span>
						</CustomButton>
					</span>
				</div>
			</div>

			<div className="bg-white rounded   mx-auto profile-bg">
				<div className="flex">
					<div className="mx-64 shrink-0" style={{ marginRight: '8.6rem' }}>
						<Avatar src={user?.thumb} style={{ height: '140px', width: '140px' }} />
					</div>
					{isLoading ? (
						<CircularProgress className="m-auto justtify-center items-center" />
					) : (
						<div className="grid grid-cols-2 flex-grow pl-20" style={{ gap: '40px', marginRight: '6.4rem' }}>
							<div className="">
								<div style={{ fontSize: 14 }}>First Name</div>
								<div className="font-bold turncate break" style={{ fontSize: 16 }}>
									{user.first_name}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Last Name</div>
								<div className="font-bold turncate break" style={{ fontSize: 16 }}>
									{user.last_name}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Contact Number</div>
								<div className="font-bold turncate break" style={{ fontSize: 16 }}>
									{user.phone}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Email Address</div>
								<div className="font-bold turncate break" style={{ fontSize: 16 }}>
									{user.email}
								</div>
							</div>
							<div className="reest-pass">
								{/* <h1 className='hd-main PASS'>  Password</h1> */}
								<span
									className="pass-imp"
									style={{
										fontSize: '18px',
										display: 'block',
										paddingBottom: '26px',
										fontWeight: '700',
									}}
								>
									{' '}
									Password
								</span>
								<span className="mx-4 pass-btn">
									<CustomButton
										fontSize="15px"
										height="46"
										onClick={() => handleResetDialoguebox()}
										variant="secondary"
										width="160px"
									>
										<span> Reset Password</span>
									</CustomButton>
								</span>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default SuperadminDetail;
